// extracted by mini-css-extract-plugin
export var container = "_4r-0";
export var containerTopRight = "_4r-1";